import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { formatDateNew } from "~/helpers/formatDate"
import { pluralize } from "~/helpers/pluralize"

import styles from "./index.module.css"

type Props = {
  date: Date
  video: null | string
  gallery: string[] | null
}

export const Label: React.FC<Props> = ({ video, date, gallery }) => {
  const { t } = useTranslation()

  return (
    <>
      {!video && !gallery && (
        <Heading className={styles.Date} like="h5">
          {formatDateNew(date, "d MMMM yyyy")}
        </Heading>
      )}

      {video && (
        <Heading className={styles.Date} like="h5">
          <div
            className={styles.Video}
            dangerouslySetInnerHTML={{ __html: t("newsCard.Video.Title") }}
          />
        </Heading>
      )}

      {gallery && (
        <Heading className={styles.Date} like="h5">
          {gallery.length}{" "}
          {pluralize(gallery.length, [
            t("newsCard.Video.Photo.Pluralize.01"),
            t("newsCard.Video.Photo.Pluralize.02"),
            t("newsCard.Video.Photo.Pluralize.03"),
          ])}
        </Heading>
      )}
    </>
  )
}
